import React from 'react';

import {useMatchMedia} from '@udemy/hooks';
import {useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';
import {Meter} from '@udemy/react-messaging-components';
import {TakeOverWizard} from '@udemy/react-structure-components';

interface StepLayoutProps {
    children: React.ReactNode;
    footerRightChildren: React.ReactNode;
    footerLeftChildren?: React.ReactNode;
    progressValue: number;
    title?: string;
    onClose: () => void;
}

export const StepLayout = ({
    children,
    footerRightChildren,
    footerLeftChildren,
    progressValue,
    title,
    onClose,
}: StepLayoutProps) => {
    const {gettext} = useI18n();
    const isMobile = useMatchMedia('mobile-max');

    return (
        <TakeOverWizard
            fullScreenHeight={false}
            headerProps={{
                renderLogo: isMobile ? () => <></> : undefined,
                centerChildren: title ?? gettext("How's your learning going?"),
                rightChildren: (
                    <Button udStyle="ghost" size="medium" onClick={onClose}>
                        {gettext('Close')}
                    </Button>
                ),
                progressBar: (
                    <Meter
                        value={progressValue}
                        min={0}
                        max={100}
                        label={gettext('Survey progress')}
                    />
                ),
            }}
            footerProps={{rightChildren: footerRightChildren, leftChildren: footerLeftChildren}}
        >
            {children}
        </TakeOverWizard>
    );
};
